import React, { useEffect, useState } from 'react';
import './point-of-sale-container.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBasket } from '@fortawesome/free-solid-svg-icons';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';

const PointOfSaleContainer = ({
  gameData,
  playerList,
  gameElements,
  gameStats
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [cart, setCart] = useState([]);
  const [ elementList, setElementList ] = useState([]);
  const [ elementsToView, setElementsToView ] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!gameElements) return;
    const marketItems = Object.values(gameElements).filter(item => item.opt_market && item.opt_marketPrice > 0);
    setElementList(marketItems);
    setElementsToView(marketItems);
  }, [gameElements])

  const addToCart = (item) => {
    setCart(prevCart => {
      const existing = prevCart.find(i => i.id === item.id);
      if (existing) {
        return prevCart.map(i => i.id === item.id ? { ...i, qty: i.qty + 1 } : i);
      }
      return [...prevCart, { ...item, qty: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart(prevCart => prevCart.filter(item => item.id !== id));
  };

  function search(query) {
    if (!query) {
      setElementsToView(elementList);
    } else {
      const lowerQuery = query.toLowerCase();
      setElementsToView(elementList.filter(item => item.name.toLowerCase().includes(lowerQuery)));
    }
  }

  const cartTotal = cart.reduce((sum, item) => sum + (item.opt_marketPrice * item.qty), 0);

  return (
    <div className={`pos-container g-card ${screenSize}`} >
      <BackButton cancel={() => navigate(-1)} />
      <div className="g-space-1"></div>
      <div className="card-title">
        <FontAwesomeIcon icon={faShoppingBasket} />
        <span>Point of Sale</span>
      </div>

      <hr  />
      
      <SearchBar search={search} idLabel={"search-items"} />
      <div className='g-space-1'></div>
      <div className="pos-grid">

        {/* LEFT: ITEM GRID */}
        <div className="item-grid">
          
          {elementsToView.map(item => (
            <div 
              key={item.id} 
              className="item-card g-card clickable with-shadow" 
              onClick={() => addToCart(item)} >
                <ImageContainer
                  src={item.icon} // Logic for your storage path
                  alt={item.name}
                  className="item-icon"
                  onError={(e) => e.target.src = 'https://via.placeholder.com/150?text=Item'}
                />
                <div className="element-name">
                  {
                    item.name.length > 40
                      ? item.name.slice(0, 37) + '...'
                      : item.name
                  }
                </div>
                <div className="meta element-cost">
                  <ImageContainer src="/images/icons/coin.png" className="icon-small" />
                  {item.opt_marketPrice}
                </div>
                <div></div>
                <button className="g-button primary small-btn static" style={{ width: '100%' }}>
                  Add to Cart
                </button>
              </div>
          ))}
        </div>

        {/* RIGHT: SHOPPING CART */}
        <div className="cart-section">
          <div className="g-list-item">
            <div className='cart-header'>
              <span>Shopping Cart</span>
              <span className="badge" >
                {cart.length} items
              </span>
            </div>
            <hr className="small-margin" />

            {cart.length === 0 ? (
              <div className='empty-message'>Cart is empty</div>
            ) : (
              <div className="cart-items">
                {cart.map(item => (
                  <div key={item.id} className="cart-item g-list-item grey-background">                   
                    <div className="element-name">
                      <ImageContainer src={item.icon} alt={item.name} className="icon-med" />
                      {item.name}
                    </div>
                    <div className="cost-remove">
                      <div className="meta element-cost">
                        <span>Qty: <strong>{item.qty}</strong></span>
                        <div></div>
                        <span>Total:</span>
                        <ImageContainer src="/images/icons/coin.png" className="icon-small" />
                        {item.opt_marketPrice * item.qty}
                      </div>
                      <button
                        className="g-button text-only red tiny-btn"
                        onClick={() => removeFromCart(item.id)}
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <hr />

            <div className="cart-total" >
              <div className="">Total:</div>
              <div className="total-cost">
                <ImageContainer src="/images/icons/coin.png" className="icon-med" />
                {cartTotal}
              </div>
            </div>
            <div className="g-space-1" />

            <button
              className={`g-button primary big-btn ${cart.length === 0 ? 'disabled' : ''}`}
              style={{ width: '100%' }}
              onClick={() => alert('Processing Transaction...')}
            >
              Complete Purchase
            </button>

            <button
              className="g-button text-only"
              style={{ width: '100%', marginTop: '10px' }}
              onClick={() => setCart([])}
            >
              Clear Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PointOfSaleContainer